module.exports = __webpack_public_path__ + "static/media/result_fail.1283aa28.png";


//////////////////
// WEBPACK FOOTER
// ./src/public/result_fail.png
// module id = 1123
// module chunks = 0